import React, { useState, useEffect } from "react";
import { Table, message, Space, Image, Row, Button, Col, Skeleton } from "antd";
import { EditableCell, EditableRow } from "./EditableCell";
import { defaultOptions } from "./RenderFields";
import { getConvertedValue } from "utils/helpers";
import axios from "axios";
import API_KEY from "api/index";
import VariantModal from "./Variant/index";
import { DeleteFilled } from "@ant-design/icons";
import { getData, sendData } from "store/firebase/methods";

const renderSuffix = (text) =>
  text?.location
    ? `/b_rgb:f2f2f2,c_pad,h_72,q_100,w_72/${text?.file}`
    : `assets/${text?.file}?transforms=[["resize",{"width":100,"height":100,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`;

const previewSuffix = (text) =>
  text?.location
    ? `/b_rgb:f2f2f2,c_pad,h_600,q_100,w_600/${text?.file}`
    : `assets/${text?.file}?transforms=[["resize",{"width":600,"height":600,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`;
export default function EditableTable({
  data,
  defaults,
  saving,
  setSaving,
  showCost,
  loadingProductCost,
  setLoadingProductCost,
  setProductCount,
}) {
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [variantData, setVariantData] = useState([]);
  const [deleted, setDeleted] = useState(false);
  const [collectionProductId, setCollectionProductId] = useState(null);
  const [activeProductId, setActiveProductId] = useState(null);
  const [isSizeChanged, setSizeChanged] = useState(false);
  const [isPriceChanged, setPriceChanged] = useState(false);
  const [isVariantModalVisible, setIsVariantModalVisible] = useState(false);
  const [customColumns, setCustomColumns] = useState([]);
  const [attrValueId, setAttrValueId] = useState({});
  // useEffect(() => {
  //   if (data) {
  //     setColumns((state) => state);
  //     // createColumns(data?.columns);
  //     // // createDataSource(data?.data_source);
  //     setDataSource((state) => state);
  //     setProductCount(dataSource.length);
  //     if (deleted) {
  //       setDeleted(false);
  //     }
  //   }
  // }, [deleted]);

  useEffect(() => {
    if (data) {
      setLoadingProductCost(true);
      const updatedColumns = columns.map((item) => {
        return item.name === "Product Cost"
          ? { ...item, visible: showCost }
          : { ...item };
      });
      setColumns(updatedColumns);
      // setDataSource((state) => state);
    }
    setLoadingProductCost(false);
  }, [showCost]);

  // }, [showCost]);

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  useEffect(() => {
    if (data) {
      createColumns(data?.columns);
      createDataSource(data?.data_source);
    }
  }, [data]);

  // create columns
  const createColumns = (data) => {
    setColumns([
      {
        title: "Delete",
        name: "Delete",
        dataIndex: "deleteId",
        key: "deleteId",
        fixed: "left",
        align: "center",
        visible: true,
        width: 100,
        // className: "light-cyan",
        render: (deleteId, record) => (
          <DeleteFilled
            style={{ color: "#B4B7B6", fontSize: "1.2rem" }}
            onClick={() => handleDelete(record)}
          />
        ),
      },
      ...data?.flatMap((item, index) => {
        if (item?.type === "price" && item?.is_internal === false) {
          return [
            {
              ...item,
              title: (
                <select
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    minWidth: 100,
                    padding: "0px 10px",
                  }}
                  onChange={(e) => {
                    handlePriceChange(
                      e?.target?.value,
                      `${item.name}_currency`
                    ); //bulk edit all columns
                  }}
                >
                  <option disabled selected value>
                    Currency
                  </option>
                  {defaultOptions.price.currency.map((unit, index) => (
                    <option key={index} value={unit}>
                      {unit}
                    </option>
                  ))}
                </select>
              ),
              dataIndex: `${item.name}_currency`,
              key: index,
              visible: item?.visible,
              width: 150,
              editable: item?.attribute_id ? true : false,
            },
            {
              ...item,
              title: item?.name,
              dataIndex: item?.name,
              key: index + 1,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              // className: item?.color ? "light-cyan" : "light-yellow",
              width: 120,
            },
            {
              ...item,
              title: (
                <select
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    width: 100,
                    padding: "0px 10px",
                  }}
                  onChange={(e) => {
                    handlePriceChange(e?.target?.value, `${item.name}_unit`); //bulk edit all columns
                  }}
                >
                  <option disabled selected value>
                    Unit
                  </option>
                  {defaultOptions.price.unit.map((unit, index) => (
                    <option key={index} value={unit}>
                      {unit}
                    </option>
                  ))}
                </select>
              ),
              dataIndex: `${item.name}_unit`,
              key: index + 2,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              // className: item?.color ? "light-cyan" : "light-yellow",
              width: 150,
            },
          ];
        } else if (item?.type === "price" && item?.is_internal === true) {
          return [
            {
              ...item,
              title: (
                <div
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    width: 100,
                    padding: "0px 10px",
                  }}
                >
                  Currency
                </div>
              ),
              dataIndex: `${item.name}_currency`,
              key: index,
              visible: item?.visible,
              width: 150,
              editable: false,
              disable: true,
            },
            {
              ...item,
              title: item?.name,
              dataIndex: item?.name,
              key: index + 1,
              visible: item?.visible,
              editable: false,
              width: 150,
              disable: true,
              // className: item?.color ? "light-cyan" : "light-yellow",
            },
            {
              ...item,
              title: (
                <div
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    width: 100,
                    padding: "0px 10px",
                  }}
                >
                  Unit
                </div>
              ),
              dataIndex: `${item.name}_unit`,
              key: index + 2,
              visible: item?.visible,
              editable: false,
              // className: item?.color ? "light-cyan" : "light-yellow",
              width: 150,
              disable: true,
            },
          ];
        } else if (item?.type === "size" && item?.is_internal === false) {
          return [
            {
              ...item,
              title: item?.name,
              dataIndex: item?.name,
              key: index,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              // className: item?.color ? "light-cyan" : "light-yellow",
              width: 300,
            },
            {
              ...item,
              title: (
                <select
                  style={{
                    background: "transparent",
                    marginRight: 4,
                    borderStyle: "none",
                    outlineStyle: "none",
                    outline: "none",
                    minWidth: 100,
                    padding: "0px 10px",
                  }}
                  onChange={(e) => {
                    handleSizeUnitChange(e?.target?.value, item.name); //bulk edit all columns
                  }}
                >
                  <option disabled selected value>
                    Unit
                  </option>
                  {["cms", "inches"].map((unit, index) => (
                    <option key={index} value={unit}>
                      {unit}
                    </option>
                  ))}
                </select>
              ),
              dataIndex: `${item.name}_unit`,
              key: index + 1,
              visible: item?.visible,
              editable: item?.attribute_id ? true : false,
              // className: item?.color ? "light-cyan" : "light-yellow",
              width: 140,
            },
          ];
        } else if (item?.type === "image") {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: item?.attribute_id ? true : false,
            // className: item?.color ? "light-cyan" : "light-yellow",
            minWidth: 100,
            align: "center",
            fixed: "left",
            render: (text, record) => {
              const endpoint = text?.location
                ? process.env.REACT_APP_CLOUDINARY
                : process.env.REACT_APP_DIRECTUS;
              return (
                <Row justify="center">
                  <Col>
                    <Image
                      src={`${endpoint}${renderSuffix(text)}`}
                      alt="product"
                      width="100px"
                      height="100px"
                      style={{ borderRadius: 8 }}
                      preview={{
                        mask: (
                          <Space direction="vertical" align="center">
                            Preview
                          </Space>
                        ),
                        src: `${endpoint}${previewSuffix(text)}`,
                      }}
                    />
                  </Col>
                </Row>
              );
            },
          };
        } else if (item?.name === "Product ID") {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: item?.attribute_id ? true : false,
            // className: item?.color ? "light-cyan" : "light-yellow",
            width: 120,
            fixed: "left",
            render: (text, record) => {
              let productDetails = record.productData.filter(
                (item) => item.name === "Product ID"
              )[0];
              return (
                <div>
                  <Row>
                    <Col>{text} </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        style={{ margin: 0, padding: 0 }}
                        type="link"
                        onClick={() => {
                          handleViewVariant(record?.product_id, record);
                        }}
                      >
                        {productDetails.has_variant
                          ? `${productDetails.variant_count} variants`
                          : ""}
                      </Button>
                    </Col>
                  </Row>
                </div>
              );
            },
          };
        } else if (item?.name === "Category") {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: item?.attribute_id ? true : false,
            // className: item?.color ? "light-cyan" : "light-yellow",
            width: 140,
            fixed: "left",
          };
        } else if (item?.name === "Sub Category") {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: true,
            width: 180,
          };
        } else {
          return {
            ...item,
            title: item?.name,
            dataIndex: item?.name,
            key: index,
            visible: item?.visible,
            editable: item?.attribute_id ? true : false,
            // className: item?.color ? "light-cyan" : "light-yellow",
            width: 180,
          };
        }
      }),
    ]);
  };

  // create dataSource
  const createDataSource = (data) => {
    if (data) {
      var productData = [];

      for (let productId in data) {
        let product = data[productId];

        const rowData = product?.flatMap((item, index) => {
          //WIP - need to check condition for price type & internal || disable
          if (item?.type === "price") {
            return [
              {
                product_id: productId,
                [item?.name]: item?.value,
              },
              {
                product_id: productId,
                [`${item?.name}_currency`]: item?.sub_columns.filter(
                  (item) => item?.name === "currency"
                )?.[0]?.value,
              },
              {
                product_id: productId,
                [`${item?.name}_unit`]: item?.sub_columns.filter(
                  (item) => item?.name === "unit"
                )?.[0]?.value,
              },
            ];
          } else if (item.type === "size") {
            let composite = item[item.name] || {};
            return [
              {
                product_id: productId,
                [`${item?.name}`]: {
                  length: composite.length,
                  width: composite.width,
                  height: composite.height,
                },
              },
              {
                product_id: productId,
                [`${item?.name}_unit`]: composite.unit,
              },
            ];
          } else {
            return {
              product_id: productId,
              [item?.name]: item?.value,
              productData: product,
            };
          }
        });

        productData.push(Object.assign({}, ...rowData));
      }

      setDataSource(productData);
    }
  };

  // when columns are set do customisation
  useEffect(() => {
    if (columns.length > 0) {
      const filteredColumns =
        (columns.length > 0 &&
          columns.filter(
            (item) =>
              item.visible === true ||
              (item.name === "Product Cost" && showCost)
          )) ||
        [];
      const filteredAttributeNames = filteredColumns.map((item) => item?.name);
      const uniqueAttributes = [...new Set(filteredAttributeNames)];
      const colorMap = {};
      for (let i = 0; i < uniqueAttributes.length; i++) {
        colorMap[uniqueAttributes[i]] =
          i % 2 === 0 ? "light-cyan" : "light-yellow";
      }
      let coloredColumns = filteredColumns.map((item) => {
        return { ...item, className: colorMap[item.name] };
      });
      setCustomColumns(
        coloredColumns.length > 0 &&
          coloredColumns.map((col) => {
            if (!col.editable) {
              return col;
            }

            return {
              ...col,
              onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
                type: col?.type,
                defaults: defaults,
                saving: saving,
                setSaving: setSaving,
                isSizeChanged: isSizeChanged,
                setSizeChanged: setSizeChanged,
                isPriceChanged: isPriceChanged,
                setPriceChanged: setPriceChanged,
                isDeleted: deleted,
                setDeleted: setDeleted,
                dataSource: dataSource,
                attrValueId: attrValueId,
                setAttrValueId: setAttrValueId,
                disable: col?.disable,
              }),
            };
          })
      );
    }
  }, [columns, dataSource]);

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex(
      (item) => row?.product_id === item?.product_id
    );
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
    // setProductCount(dataSource.length);
  };

  const showVariantModal = () => {
    setIsVariantModalVisible(true);
    // setCurrency(null);
    // setUnit(null);
    // setSizeUnit(null);
  };

  const handleSizeUnitChange = (value, key) => {
    setDataSource((state) => {
      return state.map((item) => {
        let oldValues = item[key];
        let oldUnit = item[`${key}_unit`] || "";
        if (oldUnit && oldUnit != value) {
          Object.keys(oldValues).map(function (current, index) {
            oldValues[current] = getConvertedValue(oldValues[current], value);
          });
        }

        return {
          ...item,
          [key]: { ...oldValues, unit: value },
          [`${key}_unit`]: value,
        };
      });
    });

    // setProductCount(dataSource.length);
    setSizeChanged(true);
  };

  const handlePriceChange = (value, key) => {
    setDataSource((state) => {
      return state.map((item) => {
        return {
          ...item,
          [key]: value,
        };
      });
    });
    setPriceChanged(true);
  };

  const handleOkVariant = () => {
    setIsVariantModalVisible(false);
  };

  const handleCancelVariant = () => {
    setIsVariantModalVisible(false);
  };
  const handleViewVariant = (id, record) => {
    // setActiveProductId(record?.product_id);
    // setCollectionProductId(id);
    // setVariantData([]);
    const userData = localStorage.getItem("user");
    const user = userData && JSON.parse(userData);
    axios
      .get(
        `${process.env.REACT_APP_API_SERVICE}items/table/collection_products_variants`,
        {
          params: {
            collection_product_id: id,
            access_token: user?.access_token,
          },
        }
      )
      .then((res) => {
        setVariantData(res?.data);
        showVariantModal();
      })
      .catch((err) => {
        console.log(err, "err");
      });
    // API_KEY.URL.get(`${API_KEY.path.variantModal}/${id}`)
    //   .then((res) => {
    //     setVariantData(res?.data?.result?.variants);
    //     showVariantModal();
    //   })
    //   .catch((err) => {
    //     console.log(err, "err");
    //   });
  };

  const handleDelete = (record) => {
    getData()
      .then((selectedProducts) => {
        let selectedProductsArray = selectedProducts.filter(
          (item) => item.product_id !== record["Product ID"]
        );
        sendData(selectedProductsArray);
        setProductCount(selectedProductsArray.length);
        API_KEY.URL.delete(
          `${API_KEY.path.collection_products}/${record?.product_id}`
        )
          .then((res) => {
            if (res.status === 200) {
              setDataSource((state) => {
                return state.filter(
                  (item) => item?.product_id !== record?.product_id
                );
              });
              setDeleted(true);
              setSaving(false);

              message.success("Product deleted successfully");
            }
          })
          .catch((err) => setSaving(false));
      })
      .catch((e) => {
        console.log("error deleting product: ", e);
      });
  };
  return dataSource.length ? (
    loadingProductCost ? (
      <Skeleton active />
    ) : (
      <div>
        <VariantModal
          isVariantModalVisible={isVariantModalVisible}
          setIsVariantModalVisible={setIsVariantModalVisible}
          handleOkVariant={handleOkVariant}
          handleCancelVariant={handleCancelVariant}
          variantData={variantData}
          activeProductId={activeProductId}
          // unit={unit}
          // sizeUnit={sizeUnit}
          // setUnit={setUnit}
          // setSizeUnit={setSizeUnit}
          // currency={currency}cd
          // setCurrency={setCurrency}
          collectionProductId={collectionProductId}
          // customAttrs={customAttrs}
        />
        <Table
          components={components}
          bordered
          dataSource={dataSource}
          columns={customColumns}
          pagination={false}
          scroll={{ x: "max-content", y: "65vh" }}
          // sticky
        />
      </div>
    )
  ) : (
    <Skeleton active />
  );
}
